import React from 'react';
import PropTypes from 'prop-types';

const SvgDelete = ({ active, ...props }) => {
    const fillColor = active ? '#128383' : '#EAEBF0';
    const strokeColor = active ? '#ffffff' : '#343A72';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26" {...props}>
            <rect
                width="8.067"
                height="1.344"
                x="9.067"
                y="1"
                fill={strokeColor}
                stroke={strokeColor}
                strokeWidth="1.25"
                rx=".672"
            />
            <path
                fill={fillColor}
                stroke={strokeColor}
                strokeWidth="1.25"
                d="M1 5.033a2.689 2.689 0 0 1 2.689-2.689H22.51a2.689 2.689 0 0 1 2.689 2.69c0 .742-.602 1.344-1.344 1.344H2.344A1.344 1.344 0 0 1 1 5.033Z"
            />
            <path
                fill={fillColor}
                stroke={strokeColor}
                strokeWidth="1.25"
                d="M3.017 6.378h20.166l-1.212 16.965a2 2 0 0 1-1.994 1.857H6.223a2 2 0 0 1-1.995-1.857L3.017 6.378Z"
            />
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M13.1 20.83V10.076m4.706 10.754.672-10.755M8.394 20.83l-.672-10.755"
            />
        </svg>
    );
};
SvgDelete.propTypes = {
    active: PropTypes.bool,
};
SvgDelete.defaultProps = {
    active: false,
};

export default SvgDelete;
